import { __assign, __extends } from "tslib";
import * as React from 'react';
import { TooltipHost, TooltipDelay } from '@fluentui/react/lib/Tooltip';
import { getDocumentTitleCalloutLocationStyles, getDocumentTitleCalloutToolTipStyles, getMoveButtonStyles, } from './DocumentTitleCalloutLocation.styles';
import { LogCategory, TraceLevel, ULS } from '@ms/office-online-telemetry/lib/';
import { Icon } from '@fluentui/react/lib/Icon';
import { AppBaseButton } from '@ms/app-commanding-ui/lib/UISurfaces/controls/AppBaseButton';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { sendTelemetryEvent } from '@ms/office-online-otel';
import { AppThemeConsumer } from '@ms/acui-theme';
var DocumentTitleCalloutLocation = /** @class */ (function (_super) {
    __extends(DocumentTitleCalloutLocation, _super);
    function DocumentTitleCalloutLocation(props) {
        var _this = _super.call(this, props) || this;
        _this.onMainFolderLocationClicked = function () {
            _this.onBreadcrumbLocationClicked('MainFolder');
        };
        _this.onSubFolderLocationClicked = function () {
            _this.onBreadcrumbLocationClicked('SubFolder');
        };
        _this.onBreadcrumbLocationClicked = function (location) {
            // Used via Insights team as HeaderBreadcrumbLinkClicked in the scorecard
            // ASSERTTAG_IGNORE_START
            ULS.sendTraceTag(0x238226d2 /* tag_9681s */, LogCategory.msoulscat_Wac_Ribbon, TraceLevel.Info, 'DTT breadcrumb location clicked.');
            // ASSERTTAG_IGNORE_FINISH
            sendTelemetryEvent({
                name: 'Office.FileIO.Online.DTT.BreadcrumbClicked',
                dataFields: [{ name: 'Location', string: location }],
            });
            _this.props.cleanupAndDismissCalloutCallback();
        };
        _this.onMoveButtonClick = function () {
            if (_this.props.onMove) {
                sendTelemetryEvent({
                    name: 'Office.FileIO.Online.DTT.MoveButtonClicked',
                });
                _this.props.onMove();
                _this.props.cleanupAndDismissCalloutCallback();
            }
        };
        return _this;
    }
    DocumentTitleCalloutLocation.prototype.render = function () {
        var _this = this;
        var colors = this.props.colors;
        return (React.createElement(AppThemeConsumer, null, function (theme) {
            var documentTitleCalloutLocationStyles = getDocumentTitleCalloutLocationStyles(theme, colors);
            return (React.createElement("div", { className: documentTitleCalloutLocationStyles.classNames.documentLocationSection },
                React.createElement("span", { className: documentTitleCalloutLocationStyles.classNames.sectionName }, _this.props.strings.location),
                React.createElement("div", { className: documentTitleCalloutLocationStyles.classNames.rowOrientation },
                    React.createElement("div", { className: documentTitleCalloutLocationStyles.classNames.documentLocation },
                        React.createElement(Icon, __assign({ className: documentTitleCalloutLocationStyles.classNames.folderIcon }, _this.props.icons.folder)),
                        _this.renderBreadcrumb(documentTitleCalloutLocationStyles.classNames)),
                    _this.props.isMoveEnabled &&
                        _this.props.onMove &&
                        _this.renderMoveButton(theme, documentTitleCalloutLocationStyles.classNames))));
        }));
    };
    DocumentTitleCalloutLocation.prototype.renderBreadcrumb = function (classNames) {
        var _a = this.props, breadcrumbBrandName = _a.breadcrumbBrandName, breadcrumbBrandUrl = _a.breadcrumbBrandUrl, breadcrumbFolderName = _a.breadcrumbFolderName, breadcrumbFolderUrl = _a.breadcrumbFolderUrl;
        var breadcrumbBrandNameProps = {
            'data-unique-id': 'BreadcrumbBrandName',
        };
        var breadcrumbFolderNameProps = {
            'data-unique-id': 'BreadcrumbFolderName',
        };
        return (React.createElement("nav", null,
            React.createElement("div", { className: classNames.breadcrumbContainer, "aria-label": this.props.strings.accessibilityMainFolder },
                React.createElement("a", __assign({ href: breadcrumbBrandUrl, target: "_top", rel: "noopener noreferrer", className: classNames.breadcrumbItem, onClick: this.onMainFolderLocationClicked }, breadcrumbBrandNameProps), breadcrumbBrandName),
                breadcrumbFolderName ? (React.createElement(React.Fragment, null,
                    React.createElement(Icon, __assign({ className: classNames.locationChevron }, this.props.icons.chevronRight)),
                    React.createElement("div", { className: classNames.flexContainer, "aria-label": this.props.strings.accessibilitySubFolder },
                        React.createElement("a", __assign({ href: breadcrumbFolderUrl, target: "_top", rel: "noopener noreferrer", className: classNames.breadcrumbItem, onClick: this.onSubFolderLocationClicked }, breadcrumbFolderNameProps), breadcrumbFolderName)))) : null)));
    };
    DocumentTitleCalloutLocation.prototype.renderMoveButton = function (theme, classNames) {
        var _this = this;
        var moveButtonProps = {
            'data-unique-id': 'MoveButton',
            onClick: this.onMoveButtonClick,
        };
        return (React.createElement("div", { className: classNames.moveButton },
            React.createElement(TooltipHost, { tooltipProps: {
                    onRenderContent: function () { return React.createElement("span", null, _this.props.strings.moveTooltip); },
                }, delay: TooltipDelay.zero, id: "MoveToolTip", directionalHint: DirectionalHint.bottomCenter, styles: getDocumentTitleCalloutToolTipStyles() },
                React.createElement(AppBaseButton, __assign({ styles: getMoveButtonStyles(theme), className: classNames.moveButtonContainer, ariaLabel: this.props.strings.moveTooltip }, moveButtonProps),
                    React.createElement(Icon, __assign({ className: classNames.chevron }, this.props.icons.chevronRight))))));
    };
    return DocumentTitleCalloutLocation;
}(React.PureComponent));
export { DocumentTitleCalloutLocation };
//# sourceMappingURL=DocumentTitleCalloutLocation.js.map